import { format, formatDateTime } from '@cbgms/base/utils/datetime'

interface Props {
  content: string
}

export function DateTime({ content }: Props) {
  return <>{formatDateTime(content, format.longDateFormat)}</>
}
